import React from 'react';
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {getNotesDeleteModalStatus} from "../../../redux-store/selectors";
import {setDeleteModalStatus} from "../../../redux-store/notes";

const NotesConfirmationModal = ({onSubmit}) => {
    const dispatch = useDispatch();

    const show = useSelector(getNotesDeleteModalStatus);

    const onClose = ()=>{
        dispatch(setDeleteModalStatus(false));
    }
    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title>Potvrda brisanja</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <h5>Da li ste sigurni da želite obrisati ovaj alarm?</h5>
                </div>
                <div className={"modal-footer-component text-right"}>
                    <button className={"btn btn-modal-cancel"} onClick={onClose}>
                        Odustani
                    </button>
                    <button className={"btn btn-modal-confirm-delete"} onClick={onSubmit}>Obriši</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default NotesConfirmationModal;